export default "__VITE_ASSET__6c4d7669__"